import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

import { environment } from '@env/environment';
import { AccountType } from '@shared/enums';
import { Client, BaseAccount } from '@shared/models';
import { ToastNotificationService } from '@shared/services';

@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountDetailsComponent implements OnChanges {
  @Input({ required: true }) baseAccount: BaseAccount;
  @Input({ required: true }) selectedClient: Client;
  @Input({ required: true }) clientsList: Client[];
  @Input({ required: true }) isAppOnline: boolean;

  @Output() selected = new EventEmitter<string>();
  @Output() goToMyAccount = new EventEmitter();
  @Output() signOut = new EventEmitter();

  @ViewChild(MatMenuTrigger) menuTriggerButton: MatMenuTrigger;

  isSystemAdmin: boolean;

  myAccountPath = '/my-profile/account';
  coreModule: typeof environment.coreModule = environment.coreModule;
  appVersion = environment.appVersion;

  constructor(private toastNotificationService: ToastNotificationService) {}

  ngOnChanges(): void {
    this.isSystemAdmin =
      this.baseAccount?.accountType === AccountType.SystemAdmin;
  }

  navigateToMyAccount(): void {
    this.goToMyAccount.emit();
  }

  onSelectClient(client: Client): void {
    this.selected.emit(client.id);
  }

  copyToClipboardNotification(): void {
    this.toastNotificationService.info(
      $localize`:@@shared.accountDetails.txtCopyToClipboard:Version number copied to clipboard`
    );
  }

  onSignOut(): void {
    this.signOut.emit();
  }

  trackClient(_index: number, client: Client): string {
    return client?.id;
  }

  onMenuTriggered(): void {
    setTimeout(() => {
      const curSelectedElement = document.getElementsByClassName(
        'accountPicker_item selectedMenuItem'
      )[0] as HTMLElement;

      curSelectedElement?.scrollIntoView({ block: 'start' });
    });
  }
}
